import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_ADMIN_PRO_RESERVATION_EVENTS = gql`
query getAdminProReservationEvents {
  getAdminProReservationEvents {
      eventSlugName
      eventName
    }
  }
`;

const getAdminProReservationEvents = async () => {
  try {
    const result = await client.query({
      query: GET_ADMIN_PRO_RESERVATION_EVENTS,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getAdminProReservationEvents: eventsData } } = result;

    if (eventsData) {
      return eventsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getAdminProReservationEvents = null`);
    return [];
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getAdminProReservationEvents Error: ${error}`);
    return [];
  }
};

export default getAdminProReservationEvents;
